/** Connect the publication controls and theme to a same-origin Deckwerk export. */
export function initPaperDecks(): void {
  const decks = [...document.querySelectorAll<HTMLElement>('[data-paper-deck]')];
  if (!decks.length) return;

  const syncThemes: Array<() => void> = [];
  for (const deck of decks) {
    const frame = deck.querySelector<HTMLIFrameElement>('iframe');
    const previous = deck.querySelector<HTMLButtonElement>('[data-deck-previous]');
    const next = deck.querySelector<HTMLButtonElement>('[data-deck-next]');
    const counter = deck.querySelector<HTMLElement>('[data-deck-counter]');
    const open = deck.querySelector<HTMLAnchorElement>('[data-deck-open]');
    if (!frame || !previous || !next || !counter || !open) continue;

    const url = new URL(frame.src, window.location.href);
    if (url.origin !== window.location.origin) continue;
    let slide = 1;
    let total = 1;

    const send = (message: object): void => {
      frame.contentWindow?.postMessage({ source: 'paper-deck-host', ...message }, url.origin);
    };
    const syncTheme = (): void => {
      send({ type: 'init', theme: document.documentElement.dataset['theme'] === 'dark' ? 'dark' : 'light' });
    };
    syncThemes.push(syncTheme);
    frame.addEventListener('load', syncTheme);
    syncTheme();

    previous.addEventListener('click', () => {
      if (slide > 1) send({ type: 'navigate', slide: slide - 1 });
    });
    next.addEventListener('click', () => {
      if (slide < total) send({ type: 'navigate', slide: slide + 1 });
    });

    window.addEventListener('message', (event: MessageEvent<unknown>) => {
      if (event.origin !== url.origin || event.source !== frame.contentWindow) return;
      if (!event.data || typeof event.data !== 'object') return;
      const state = event.data as Record<string, unknown>;
      if (state['source'] !== 'paper-deck' || state['type'] !== 'state') return;
      const current = state['slide'];
      const count = state['total'];
      if (typeof current !== 'number' || typeof count !== 'number'
        || !Number.isInteger(current) || !Number.isInteger(count)
        || count < 1 || current < 1 || current > count) return;

      slide = current;
      total = count;
      counter.textContent = `${slide} / ${total}`;
      previous.disabled = slide === 1;
      next.disabled = slide === total;
      url.hash = String(slide);
      open.href = url.href;
    });
  }

  new MutationObserver(() => syncThemes.forEach((sync) => sync())).observe(document.documentElement, {
    attributes: true, attributeFilter: ['data-theme'],
  });
}
